import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Ideation from "../../../images/industries/healthcare/mobile.webp";
import Design from "../../../images/industries/healthcare/software-2.webp";
import { Link } from "gatsby";

function Transform(props) {
  const [activeTab, setActiveTab] = useState(1);

  function displayTab(tabNumber) {
    setActiveTab(tabNumber);
  }

  return (
    <>
      <div className="tekgriping_section p-100">
        <Container className="h-100">
          <Row className="h-100">
            <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
              <div className="example" data-text="Transform">
                <h2>
                  Upgrade Your Medical Services with Our Digital Health
                  Solutions
                </h2>
              </div>
              <p>
                Our custom healthcare software and app development services are
                capable enough to level up your healthcare business like never
                before! Having a keen eye for in-depth healthcare operations, we
                utilize the latest programming frameworks and engineer the
                development porches to build a reliable digital health solution
                for you.
              </p>
            </Col>
            <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
              <div className="tekgrip_flex">
                <div className="tekgrip_title">
                  <h5>
                    11.5B
                    <span>Approx. market size</span>
                  </h5>
                </div>
                <div className="tekgrip_title">
                  <h5>
                    14.4%
                    <span>Compound annual growth rate</span>
                  </h5>
                </div>
              </div>
            </Col>
            <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
              <h3
                onClick={() => {
                  displayTab(1);
                }}
                className={`tabs ${activeTab === 1 ? "active" : ""}`}
              >
                <div className="tab_namee">
                  Healthcare Mobile App Development
                </div>
              </h3>

              <h3
                onClick={() => {
                  displayTab(2);
                }}
                className={`tabs ${activeTab === 2 ? "active" : ""}`}
              >
                <div className="tab_namee">Healthcare Software Development</div>
              </h3>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="tekgrip_tabs_iamge tekrevol_dark_bg p-100">
        <Container className="h-100">
          <Row className={activeTab === 1 ? "d-flex h-100" : "d-none h-100"}>
            <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
              <div className="tekgrip_tabs_content">
                <h2>Healthcare Mobile App Development</h2>
                <p>
                  We offer customized{" "}
                  <Link to="/healthcare-app-development">
                    healthcare mobile app development services
                  </Link>{" "}
                  that are designed to cater to your unique needs. With a focus
                  on staying ahead of the curve, we leverage the latest
                  advancements in technology and tap into our industry expertise
                  to ensure the delivery of top-notch digital healthcare
                  solutions. Our team is dedicated to providing you with
                  innovative and reliable healthcare mobile app development
                  services that enhance patient experiences.
                </p>
              </div>
            </Col>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
              <div className="tekgrip_tabs_image ">
                <LazyLoadImage
                  src={Ideation}
                  effect="blur"
                  className="img-fluid slide-top"
                  alt="Transform Your Healthcare Business"
                />
              </div>
            </Col>
          </Row>
          <Row className={activeTab === 2 ? "d-flex h-100" : "d-none h-100"}>
            <Col xs={12} md={7} lg={6} xl={6} xxl={6} className="my-auto">
              <div className="tekgrip_tabs_content">
                <h2>Healthcare Software Development</h2>
                <p>
                  Our{" "}
                  <Link to="/solution/healthcare-software-development">
                    healthcare software development services
                  </Link>{" "}
                  are designed to meet your critical business needs, providing
                  effective and result-oriented solutions that address the
                  unique challenges you face. With a solution-centric approach,
                  we strengthen your business by leveraging our expertise in
                  digital healthcare solutions. Therefore, you can easily rely
                  on our innovative and reliable software products for improving
                  overall healthcare operations, leading towards excellence in
                  the healthcare sector.
                </p>
              </div>
            </Col>
            <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
              <div className="tekgrip_tabs_image ">
                <LazyLoadImage
                  src={Design}
                  effect="blur"
                  alt="Healthcare Software Development"
                  className="img-fluid slide-top"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Transform;
